import { useState, useEffect } from "react";
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";
import { Outlet, ScrollRestoration } from "react-router";
import { AudioPlayer } from "../components/AudioPlayer";
import { AudioPlayerProvider, Track } from "../components/AudioPlayer/context/AudioPlayerContext";
import Auth from "../pages/Auth";
import { useAuth } from "../contexts/AuthContext";
import { useGlobal } from "../contexts/GlobalContext";
import { Media, Episode } from "../types/media";
import { Modal } from "../components/ui/Modal";

export const Layout = () => {
    const { isAudioPlayerVisible, media, episode, episodes, setIsAudioPlayerVisible, setMedia, setEpisode, setEpisodes } = useGlobal();
    const { isAuthOpen, setIsAuthOpen, setCurrentScreen } = useAuth();

    const [tracks, setTracks] = useState<Track[]>([]);
    const [track, setTrack] = useState<Track>({} as Track);

    useEffect(() => {
        setTrack({ id: episode.id, title: episode.title, description: episode.description, src: episode.episodeUrl, thumbnail: media?.images?.[0] ?? "", duration: episode.duration });
    }, [episode]);

    useEffect(() => {
        setTracks(episodes.map((episode) => ({ id: episode.id, title: episode.title, description: episode.description, src: episode.episodeUrl, thumbnail: media?.images?.[0] ?? "", duration: episode.duration })));
    }, [episodes]);

    const onCloseAudioPlayer = () => {
        setIsAudioPlayerVisible(false);
        setMedia({} as Media);
        setEpisode({} as Episode);
        setEpisodes([]);
    };

    return (
        <>
            <Header />
            <section className="overflow-aut max-h-[calc(100vh-104px) md:max-h-[calc(100vh-112px)">
                <main>
                    <ScrollRestoration />
                    <Outlet />
                    <Modal isOpen={isAuthOpen} onClose={() => { setIsAuthOpen(false); setCurrentScreen("signIn"); }}>
                        <Auth />
                    </Modal>
                    <div className="py-4 pb-0 z-50 fixed bottom-[62px] md:bottom-0 left-0 right-0">
                        {isAudioPlayerVisible && <AudioPlayerProvider><AudioPlayer track={track} tracks={tracks} onClose={onCloseAudioPlayer} /></AudioPlayerProvider>}
                    </div>
                </main>
                <Footer />
            </section>
        </>
    );
};